import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { IvFormComponent } from './../../shared/components/iv-form/iv-form.component';
import { Utils } from './../../shared/utils/utils';
import { formQ } from './config/formQ';
import { formU } from './config/formU';
import { CertService, UserService } from '../../api';
import { IvCertGenericResponseCertificateClientResponse } from '../../api/model/ivCertGenericResponseCertificateClientResponse';
import { RegisterCertificateRequest } from '../../api/model/registerCertificateRequest';
import { TranslateService } from '../../core/translation/translate.service';
import { LoadingService } from './../../shared/loading/loading.service';
import { MessageService } from './../../shared/message/message.service';
import { PersonalizationsService } from '../../base/services/personalizations/personalizations.service';
import { Environment } from '../../models/environment';
import { CertificateService } from '../../finish/services/certificate.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
  providers: [CertService, UserService]
})

export class RegisterComponent implements OnInit, AfterViewInit, OnDestroy {
  /**
   * Object for the formQ IvForm Component
  */
  @ViewChild('formQ') formQ: IvFormComponent;

  /**
   * Object for the formU IvForm Component
  */
  @ViewChild('formU') formU: IvFormComponent;

  /**
   * Object for the contentQ ElementREF
  */
  @ViewChild('contentQ') contentQ: ElementRef;

  /**
   * Object for the contentU ElementREF
  */
  @ViewChild('contentU') contentU: ElementRef;

  /**
   * Object for the indicatorQ HTMLelement
  */
  @ViewChild('indicatorQ') indicatorQ: HTMLElement;

  /**
   * Object for the indicatorU HTMLElement
  */
  @ViewChild('indicatorU') indicatorU: HTMLElement;

  /**
   * Object for setting the config for FormQ
  */
  configFormQ: any = { ...formQ };

  /**
   * Object for setting the config for FormU
  */
  configFormU: any = { ...formU };

  /**
   * Object for the form error messages
  */
  erroresForm: any = {
    'required': '',
    'minlength': '',
    'maxlength': '',
    'pattern': '',
    'email': '',
    'repeat': '',
    'password': '',
    'nif': '',
    'cif': ''
  };

  /**
   * Object for form button labels
  */
  labels: any = {
    submit: '',
    clear: '',
    dialogErrorClose: '',
    dialogErrorTitle: ''
  };

  /**
   * Object for formQ button labels
  */
  labelsQ: any = {
    submit: '',
    clear: '',
    dialogErrorClose: '',
    dialogErrorTitle: ''
  };

  _transParam = false;

  /**
   * Boolean that validates if show/hide the content of the header
   */
  hideForm: boolean = false;


  /**
   *
   */
  urlTree: any;

  /**
   * String that contains the guid
   */
  guid: string;

  /**
   * Boolean that validates if the register comes with a guid
   */
  hasGuid: boolean = false;

  /**
   * Boolean that validates if show/hide register qualified
   */
  showRegisterQPers: boolean = false;

  /**
   * number that saves the actual state of the form
   */
  savedType: number;

  environment: Environment;

  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private readonly router: Router,
    private readonly CertService: CertService,
    private readonly UserService: UserService,
    public _translate: TranslateService,
    private _loading: LoadingService,
    private _message: MessageService,
    private _user: UserService,
    private _personalization: PersonalizationsService,
    private _cert: CertificateService) {
    TranslateService.initTranslateSubscription(this);
    this.environment = this._personalization.sendEnv;
  }

  ngOnInit(): void {
    this.configFormQ.certinfo.hidden = true;
  }

  translate(): void {
    this._translate.massTranslate(this.configFormQ, 'label', 'registro_form_');
    this._translate.massTranslate(this.configFormU, 'label', 'registro_form_');

    this.labels.submit = this._translate.instant('btn_guardar');
    this.labels.clear = this._translate.instant('btn_limpiar');
    this.labels.dialogErrorClose = this._translate.instant('finish_btn_close');
    this.labels.dialogErrorTitle = this._translate.instant('texto_error_titulo');

    this.labelsQ.dialogErrorClose = this._translate.instant('finish_btn_close');
    this.labelsQ.dialogErrorTitle = this._translate.instant('texto_error_titulo');

    this.erroresForm.required = this._translate.instant('form_error_required');
    this.erroresForm.minlength = this._translate.instant('form_error_min_length');
    this.erroresForm.maxlength = this._translate.instant('form_error_max_length');
    this.erroresForm.pattern = this._translate.instant('form_error_pattern');
    this.erroresForm.email = this._translate.instant('form_error_email');
    this.erroresForm.password = this._translate.instant('form_error_password');
    this.erroresForm.repeat = this._translate.instant('form_error_pass');
    this.erroresForm.nif = this._translate.instant('form_error_nif');
    this.erroresForm.cif = this._translate.instant('form_error_cif');
  }

  ngOnDestroy(): void {
    Utils.cleanObjects(this.configFormQ).then(res => {
      this.configFormQ = res;
    });
  }

  ngAfterViewInit(): void {
    this.validateGuid();
    this.validatePersType();
    this._loading.set(false);
  }

  validatePersType(): void {
    if (this.environment.features.showRegisterQualified) {
      if (!this.guid) {
        this.showRegisterQPers = true;
      }
    } else {
      this.showRegisterQPers = false;
      if (!this.guid) {
        this.ocultar_mostrar(2);
      }
    }
  }

  validateGuid(): void {
    this.urlTree = this.router.parseUrl(this.router.url);
    if (this.router.url.includes('register/')) {
      this.guid = this.router.url.slice(10);
      this.hasGuid = true;
      this.ocultar_mostrar(2);
      this.getEmail()
    } else {
      this.hasGuid = false;
    }
  }

  getEmail(): void {
    const token = 'Bearer ';
    const guid = this.router.url.split('register/')[1];
    this._user.userGetEmailByGuidInvitation(guid, token).pipe(takeUntil(this.destroy$)).subscribe((response) => {
      this.formU.Form.get('email').patchValue(response.data);
      if (this.formU.Form.get('email').value) {
        this.configFormU.email.readonly = true;
      }
    }, (error) => {
      this._message.showError(error);
    })
  }

  validateFormURL(): void {
    if (this.environment.url_api.includes('mutuamontanesa')) {
      this.hideForm = true;
    }
  }

  ocultar_mostrar(type: number): void {
    if (type === this.savedType) {
      document.getElementById('regCert').style.display = 'none';
      document.getElementById('regUser').style.display = 'none';
      this.savedType = 0;
    } else {
      this.savedType = type;
      if (type === 1) {
        document.getElementById('regCert').style.display = 'block';
        document.getElementById('regUser').style.display = 'none';

      } else if (type === 2) {
        document.getElementById('regCert').style.display = 'none';
        document.getElementById('regUser').style.display = 'block';
      }
    }
  }

  clear(form): void {
    form.Form.reset();
  }

  async fillForm(): Promise<void> {
    this._loading.set(true);
    const callbackId = await this._cert.certGate();
    this.CertService.certGetCertificateClient(callbackId, '1').pipe(takeUntil(this.destroy$)).subscribe(
      (response: IvCertGenericResponseCertificateClientResponse) => {
        const data = response.data.parseCertInfo.certinfo;

        if (data?.type == 'PRPJ' || data?.type == 'PR' || data?.type == 'PJ' || data?.type == 'PRAP') {
          if (data.org) {
            this.formQ.Form.patchValue({
              name: data?.org.name,
              username: data?.org.doc,
              email: data?.org.email
            });
            this.formQ.Form.updateValueAndValidity();
          } else if (data?.user) {
            this.formQ.Form.patchValue({
              name: data?.user.name + ' ' + data?.user.surname,
              username: data?.user.doc,
              email: data?.user.email,
              certinfo: data
            });
            this.formQ.Form.updateValueAndValidity();
          }
        } else {
          if (data?.user) {
            this.formQ.Form.patchValue({
              name: data?.user.name + ' ' + data?.user.surname,
              username: data?.user.doc,
              email: data?.user.email,
              certinfo: data
            });
            this.formQ.Form.updateValueAndValidity();
          }
        }
        this._loading.set(false);
      }, error => {
        this._loading.set(false);
        this._message.showError(error.status ? error : this._translate.instant('register_error_certificate'));
      });
  }

  submitForm(type: number): void {
    this._loading.set(true);
    const form = (type === 1) ? this.formQ : this.formU;

    if (form.Form.invalid && (type === 1)) {
      this._loading.set(false);
      form.getErrors();
    } else {
      let user: RegisterCertificateRequest;
      user = {
        name: form.Form.get('name').value,
        username: form.Form.get('username').value,
        email: form.Form.get('email').value,
        phone: form.Form.get('phone').value,
        password: form.Form.get('password').value,
        guidInvitation: this.guid
      };

      if (type === 1) {
        user.certinfo = {
          ca: form.Form.get('certinfo').value.ca,
          serialnumber: form.Form.get('certinfo').value.serialnumber,
          validFrom: form.Form.get('certinfo').value.validFrom,
          validTo: form.Form.get('certinfo').value.validTo,
          issuer: form.Form.get('certinfo').value.issuer,
          subject: form.Form.get('certinfo').value.subject,
          cn: form.Form.get('certinfo').value.cn,
          country: form.Form.get('certinfo').value.country,
          keyusage: form.Form.get('certinfo').value.keyusage,
          enhancedkeyusage: form.Form.get('certinfo').value.enhancedkeyusage,
          type: form.Form.get('certinfo').value.type,
          user: form.Form.get('certinfo').value.user,
          org: form.Form.get('certinfo').value.org,
          oid: form.Form.get('certinfo').value.oid,
          qualified: form.Form.get('certinfo').value.qualified,
          qualifiedClassification: form.Form.get('certinfo').value.qualifiedClassification
        };
      }
      user.phone = user.phone.toString();
      this.UserService.userPostRegisterCertificate(user, '1').subscribe(() => {
        this._loading.set(false);
        this._message.show(this._translate.instant('register_success_message'), 'success', this._translate.instant('dialog_success_title'));
        this.router.navigate(['/']);
      }, error => {
        this._loading.set(false);
        this._message.showError(error);
      });
    }
  }

  volver(): void {
    this.router.navigate(['/']);
  }

}